import React from "react";
import environments from "../../../../environments";
import { TransladoInternoStandard } from "./providers/standard";
import { TransladoInternoIpiranga } from "./providers/ipiranga";

export const TransladoInterno: React.FC = () => {
    switch (environments.client.name) {
        case "ipiranga":
            return <TransladoInternoIpiranga />;
        default:
            return <TransladoInternoStandard />;
    }
};
